"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Takeover = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var internal_1 = require("../../internal");
var hooks_1 = require("../../hooks");
var TakeoverHeader_1 = require("./TakeoverHeader");
var TakeoverSection_1 = require("./TakeoverSection");
var TakeoverFooter_1 = require("./TakeoverFooter");
var Takeover = function (_a) {
    var actions = _a.actions, backLabel = _a.backLabel, children = _a.children, className = _a.className, footer = _a.footer, _b = _a.footerAlign, footerAlign = _b === void 0 ? TakeoverFooter_1.TakeoverFooter.defaultProps.align : _b, onBack = _a.onBack, onClose = _a.onClose, sectioned = _a.sectioned, _c = _a.theme, theme = _c === void 0 ? TakeoverHeader_1.TakeoverHeader.defaultProps.theme : _c, contentWrapperClass = _a.contentWrapperClass, title = _a.title, _d = _a.portal, portal = _d === void 0 ? false : _d, focusScopeOptions = _a.focusScopeOptions, props = __rest(_a, ["actions", "backLabel", "children", "className", "footer", "footerAlign", "onBack", "onClose", "sectioned", "theme", "contentWrapperClass", "title", "portal", "focusScopeOptions"]);
    react_1.default.useEffect(function () {
        document.body.classList.add('Takeover--is-open');
        return function () {
            var otherOpenTakeovers = document.getElementsByClassName('Takeover').length > 1;
            if (!otherOpenTakeovers) {
                document.body.classList.remove('Takeover--is-open');
            }
        };
    }, []);
    var overlayContext = react_1.useContext(utilities_1.OverlayContext);
    var takeoverRef = react_1.useRef(null);
    var handleTab = hooks_1.useFocusScope(takeoverRef, focusScopeOptions).handleTab;
    var headerProps = {
        actions: actions,
        backLabel: backLabel,
        onBack: onBack,
        onClose: onClose,
        theme: theme,
        title: title,
    };
    var footerProps = {
        align: footerAlign,
        children: footer,
    };
    var TakeoverClasses = classnames_1.default('Takeover', className, "Takeover--" + theme);
    var contentWrapperClasses = classnames_1.default('TakeoverContent', contentWrapperClass);
    var content = utilities_1.wrapWithComponent(children, TakeoverSection_1.TakeoverSection);
    var takeover = (react_1.default.createElement("div", __assign({ className: TakeoverClasses, ref: takeoverRef, onKeyDown: handleTab }, props),
        react_1.default.createElement(utilities_1.OverlayContext.Provider, { value: overlayContext.concat('takeover') },
            react_1.default.createElement(TakeoverHeader_1.TakeoverHeader, __assign({}, headerProps)),
            react_1.default.createElement("div", { className: contentWrapperClasses }, content),
            react_1.default.createElement(TakeoverFooter_1.TakeoverFooter, __assign({}, footerProps)))));
    return react_1.default.createElement(internal_1.Portal, { conditional: portal }, takeover);
};
exports.Takeover = Takeover;
exports.Takeover.Header = TakeoverHeader_1.TakeoverHeader;
exports.Takeover.Section = TakeoverSection_1.TakeoverSection;
exports.Takeover.Footer = TakeoverFooter_1.TakeoverFooter;
//# sourceMappingURL=Takeover.js.map